export const PREVIEW_TYPE_DESKTOP = 'PREVIEW_TYPE_DESKTOP'
export const PREVIEW_TYPE_MOBILE = 'PREVIEW_TYPE_MOBILE'
export const PREVIEW_TYPE_PDF = 'PREVIEW_TYPE_PDF'

